import { Link } from "react-router-dom";
import ContentOverlay from "../components/content_overlay";

function ReportsPage() {
  return (
    <ContentOverlay
      heading={<h2 style={{ textAlign: "center" }}>Reports </h2>}
      text_content={
        <ol>
          <li>
            Conservation of Sacred Groves in Coastal Panchayats of Kerala
            <br />
            <Link
              to="/pdfs/reports/1_DPR-Conservation-of-scared-groves-MBGIPS.pdf"
              target="_blank"
            >
              Conservation-of-scared-groves-MBGIPS.pdf
            </Link>
          </li>

          <li>
            BIOLOGICAL INVASIONS
            <br />
            <Link
              to="/pdfs/reports/2_Bioinvasion-Proceedings-final-09.02.24.pdf"
              target="_blank"
            >
              Bioinvasion.pdf
            </Link>
          </li>

          <li>
            The Flora of Kerala Volume 1
            <br />
            <Link
              to="/pdfs/reports/3_The%20flora%20of%20Kerala.pdf"
              target="_blank"
            >
              The flora of Kerala.pdf
            </Link>
          </li>

          <li>
            Kerala State Biodiversity Board - Annual Report 2020-2021
            <br />
            <Link
              to="/pdfs/reports/4_Annual_Report_English_20-21web.pdf"
              target="_blank"
            >
              Annual_Report_.pdf
            </Link>
          </li>

          <li>
            Thirteenth Five-Year Plan (2017-2022) Working Group on Biodiversity
            Report
            <br />
            <Link
              to="/pdfs/reports/5_13%20Five%20Year%20Plan%20Working%20Group%20on%20Biodiversity%20Report.pdf"
              target="_blank"
            >
              13 Five Year Plan Working Group on Biodiversity Report.pdf
            </Link>
          </li>

          <li>
            Flowering Plants of Kerala: Status and Statistics
            <br />
            <Link
              to="/pdfs/reports/6_Flowering%20Plants%20of%20Kerala-Status%20and%20Statistics.pdf"
              target="_blank"
            >
              Flowering Plants of Kerala-Status and Statistics.pdf
            </Link>
          </li>

          <li>
            BIBLIOGRAPHY AND ABSTRACTS OF PAPERS ON FLORA OF KERALA
            <br />
            <Link
              to="/pdfs/reports/7_Bibliography%20and%20abstracts%20of%20papers%20on%20Flora%20of%20Kerala.pdf"
              target="_blank"
            >
              Bibliography and abstracts of papers on Flora of Kerala.pdf
            </Link>
          </li>

          <li>
            Distribution and plant diversity of mangroves in the west coast of
            Kerala, India
            <br />
            <Link
              to="/pdfs/reports/8_Distribution%20and%20plant%20diversity%20of%20mangroves%20in%20the%20West%20Coast%20of%20Kerala,%20India.pdf"
              target="_blank"
            >
              Distribution and plant diversity of mangroves in the West Coast of
              Kerala, India.pdf
            </Link>
          </li>

          <li>
            Biological Diversity of Kerala: A survey of Kalliasseri panchayat,
            Kannur district
            <br />
            <Link
              to="/pdfs/reports/9_Biological%20Survey%20of%20Kerala.pdf"
              target="_blank"
            >
              Biological Survey of Kerala.pdf
            </Link>
          </li>

          <li>
            Conservation Status and Diversity of Medicinal Plants Used in Indian
            System of Medicine - A Survey Report from the Munaru Forest
            Division, Kerala, India
            <br />
            <Link
              to="/pdfs/reports/10_Conservation%20Status%20and%20Diversity%20of%20Medicinal%20Plants%20in%20Kerala.pdf"
              target="_blank"
            >
              Conservation Status and Diversity of Medicinal Plants in
              Kerala.pdf
            </Link>
          </li>

          <li>
            RED LISTED THREATENED TREE SPECIES IN KERALA: A REVIEW
            <br />
            <Link
              to="/pdfs/reports/11_Red%20Listed%20Threatened%20Tree%20Species%20in%20Kerala_%20A%20Review.pdf"
              target="_blank"
            >
              Red Listed Threatened Tree Species in Kerala_ A Review.pdf
            </Link>
          </li>

          <li>
            Diversity of herbaceous riparian flora in the lower stretch of
            Bharathappuzha river, Kerala
            <br />
            <Link
              to="/pdfs/reports/12_Diversity%20of%20herbaceous%20riparian%20flora.pdf"
              target="_blank"
            >
              Diversity of herbaceous riparian flora.pdf
            </Link>
          </li>

          <li>
            FLORISTIC ANALYSIS OF WETLANDS OF KERALA
            <br />
            <Link
              to="/pdfs/reports/13_Floristic_Analysis_of_Wetlands_of_Kerala.pdf"
              target="_blank"
            >
              Floristic_Analysis_of_Wetlands_of_Kerala.pdf
            </Link>
          </li>

          <li>
            Observations on the flowering plant diversity of Madayippara, a
            southern Indian lateritic plateau from Kerala, India
            <br />
            <Link
              to="/pdfs/reports/14_Observation%20on%20Flowering%20Plant%20Diversity.pdf"
              target="_blank"
            >
              Observation on Flowering Plant Diversity.pdf
            </Link>
          </li>

          <li>
            Impact of flood on biodiversity of Kerala: A case study from
            Malappuram district of Kerala, India
            <br />
            <Link
              to="/pdfs/reports/15_Impact%20of%20flood%20on%20biodiversity%20of%20Kerala_Case%20study%20from%20Mallapuram%20district.pdf"
              target="_blank"
            >
              Impact of flood on biodiversity of Kerala_Case study from
              Mallapuram district.pdf
            </Link>
          </li>

          <li>
            Structure, diversity and utilization of plant species in tribal
            homegardens of Kerala, India
            <br />
            <Link
              to="/pdfs/reports/16_Structure_diversity%20and%20utilisation%20of%20plant%20species%20in%20tribal%20homegardens%20of%20Kerala.pdf"
              target="_blank"
            >
              Structure_diversity and utilisation of plant species in tribal
              homegardens of Kerala.pdf
            </Link>
          </li>

          <li>
            Agrobiodiversity in a biodiversity hotspot: Kerala State, India. Its
            origin and status
            <br />
            <Link
              to="/pdfs/reports/17_Agrobiodiversity%20in%20a%20biodiversity%20hotspot_Kerala%20State.pdf"
              target="_blank"
            >
              Agrobiodiversity in a biodiversity hotspot_Kerala State.pdf
            </Link>
          </li>

          <li>
            Diversity, structure and standing stock of wood in the homegardens
            of Kerala in peninsular India
            <br />
            <Link
              to="/pdfs/reports/18_Diversity_structure%20and%20standing%20stock%20of%20wood%20in%20the%20homegardens%20of%20Kerala%20in%20peninsular%20India.pdf"
              target="_blank"
            >
              Diversity_structure and standing stock of wood in the homegardens
              of Kerala in peninsular India.pdf
            </Link>
          </li>

          <li>
            Tree diversity and distribution in undisturbed and human-impacted
            sites of tropical wet evergreen forest in southern Western Ghats,
            India
            <br />
            <Link
              to="/pdfs/reports/19_Tree%20diversity%20and%20distribution%20in%20undisturbed%20and%20human_impacted%20sites%20of%20tropical%20wet%20evergreen%20forest%20in%20Southern%20Western%20Ghats%20India.pdf"
              target="_blank"
            >
              Tree diversity and distribution in undisturbed and human_impacted
              sites of tropical wet evergreen forest in Southern Western Ghats
              India.pdf
            </Link>
          </li>

          <li>
            Edge effects on plant diversity in tropical forest ecosystems at
            Periyar Wildlife sanctuary in the Western Ghats of India
            <br />
            <Link
              to="/pdfs/reports/20_Edge%20effects%20on%20plant%20diversity%20in%20tropical%20forest%20ecosystems%20at%20Periyar%20Wildlife%20Sanctuary%20in%20WG%20India.pdf"
              target="_blank"
            >
              Edge effects on plant diversity in tropical forest ecosystems at
              Periyar Wildlife Sanctuary in WG India.pdf
            </Link>
          </li>

          <li>
            Nutritional Evaluation of Wild Leafy Vegetables Consumed by Tribals
            in the Wayanad District of Kerala
            <br />
            <Link
              to="/pdfs/reports/21_Nutritional%20evaluation%20of%20Wild%20leafy%20vegetables%20consumed%20by%20Tribals%20in%20Wayanad%20District%20of%20Kerala.pdf"
              target="_blank"
            >
              Nutritional evaluation of Wild leafy vegetables consumed by
              Tribals in Wayanad District of Kerala.pdf
            </Link>
          </li>

          <li>
            Mangroves of Kerala
            <br />
            <Link
              to="/pdfs/reports/22_Mangroves%20of%20Kerala.pdf"
              target="_blank"
            >
              Mangroves of Kerala.pdf
            </Link>
          </li>

          <li>
            The Conservation of Mangroves in Kerala: Economic and Ecological
            Linkages
            <br />
            <Link
              to="/pdfs/reports/23_The%20Conservation%20of%20Mangroves%20in%20Kerala.pdf"
              target="_blank"
            >
              The Conservation of Mangroves in Kerala.pdf
            </Link>
          </li>

          <li>
            Ethnobotanical study of Kani tribes in Thoduhills of Kerala, South
            India
            <br />
            <Link
              to="/pdfs/reports/24_Ethnobotanical%20study%20of%20Kani%20tribes%20in%20Thoduhills%20of%20Kerala_South%20India.pdf"
              target="_blank"
            >
              Ethnobotanical study of Kani tribes in Thoduhills of Kerala_South
              India.pdf
            </Link>
          </li>

          <li>
            Floristics and indigenous knowledge of agro-climatically diverse
            Sacred groves of central Kerala
            <br />
            <Link
              to="/pdfs/reports/25_Floristics%20and%20indigenous%20knowledge%20of%20Sacred%20groves.pdf"
              target="_blank"
            >
              Floristics and indigenous knowledge of Sacred groves.pdf
            </Link>
          </li>

          <li>
            Status of crop plants of agricultural importance in Kerala state,
            India: an update
            <br />
            <Link
              to="/pdfs/reports/26_Status%20of%20crop%20plants%20of%20agricultural%20importance%20in%20Kerala%20state.pdf"
              target="_blank"
            >
              Status of crop plants of agricultural importance in Kerala
              state.pdf
            </Link>
          </li>

          <li>
            Anthropogenic pressure on structure and composition of a shola
            forest in Kerala, India
            <br />
            <Link
              to="/pdfs/reports/27_Anthropogenic%20pressure%20on%20structure%20and%20composition%20of%20a%20shola%20forest%20in%20Kerala.pdf"
              target="_blank"
            >
              Anthropogenic pressure on structure and composition of a shola
              forest in Kerala.pdf
            </Link>
          </li>

          <li>
            Status of plant bioresources utilized in herbal industries and the
            need for conservation in Kerala
            <br />
            <Link
              to="/pdfs/reports/28_Status%20of%20Plant%20Bioresources%20utilised%20in%20Herbal%20Industries%20and%20the%20need%20for%20Conservation%20in%20Kerala.pdf"
              target="_blank"
            >
              Status of Plant Bioresources utilised in Herbal Industries and the
              need for Conservation in Kerala.pdf
            </Link>
          </li>

          <li>
            Lichen Flora in Western Ghats of Kerala, India: A Source of
            Innovation
            <br />{" "}
            <a href="https://link.springer.com/chapter/10.1007/978-981-19-4336-2_7">
              Lichen flora in the Western Ghats of Kerala
            </a>
          </li>

          <li>
            Plant Biodiversity of the Silent Valley, Core Zone of Nilgiri
            Biosphere Reserve, Western Ghats, Kerala
            <br />{" "}
            <a href="https://www.researchgate.net/publication/376419996_Plant_Biodiversity_of_the_Silent_Valley_Core_Zone_of_Nilgiri_Biosphere_Reserve_Western_Ghats_Kerala">
              Plant_Biodiversity_of_the_Silent_Valley_Core_Zone_of_Nilgiri_Biosphere_Reserve_Western_Ghats_Kerala
            </a>
          </li>

          <li>
            Endemic, rare and threatened flowering plants of South India
            <br />
            <Link
              to="/pdfs/reports/31_Endemic%20rare%20and%20threatened%20flowering%20plants%20of%20South%20India.pdf"
              target="_blank"
            >
              Endemic rare and threatened flowering plants of South India.pdf
            </Link>
          </li>

          <li>
            Diversity and Status of Endemic and Threatened Angiosperm Flora of
            Coastal Ecosystems of The Central Kerala
            <br />
            <Link
              to="/pdfs/reports/32_Diversity%20and%20Status%20of%20Endemic%20and%20Threatened%20Angiosperm.pdf"
              target="_blank"
            >
              Diversity and Status of Endemic and Threatened Angiosperm.pdf
            </Link>
          </li>

          <li>
            Vegetation status, species diversity and endemism of Sulimundi
            forests in Southern Western Ghats of Kerala, India
            <br />
            <Link
              to="/pdfs/reports/33_Vegetation_Species%20diversity%20of%20Sulimudi%20forest%20in%20Southern%20Western%20Ghats%20of%20Kerala.pdf"
              target="_blank"
            >
              Vegetation_Species diversity of Sulimudi forest in Southern
              Western Ghats of Kerala.pdf
            </Link>
          </li>

          <li>
            Grass Diversity of Kerala &ndash; Endemism and its Phytogeographical
            Significance
            <br />
            <Link
              to="/pdfs/reports/34_Grass%20Diversity%20of%20Kerala.pdf"
              target="_blank"
            >
              Grass Diversity of Kerala.pdf
            </Link>
          </li>

          <li>
            FLORA OF INDIA
            <br />
            <Link to="/pdfs/reports/35_FLORA%20OF%20INDIA.pdf" target="_blank">
              FLORA OF INDIA.pdf
            </Link>
          </li>

          <li>
            Future of Endemic Flora of Biodiversity Hotspots in India
            <br />
            <Link
              to="/pdfs/reports/36_Future%20of%20Endemic%20Flora%20in%20India.pdf"
              target="_blank"
            >
              Future of Endemic Flora in India.pdf
            </Link>
          </li>

          <li>
            Plant diversity in six forest types of Uttaranchal, Central
            Himalaya, India
            <br />
            <Link
              to="/pdfs/reports/37_Plant%20diversity%20in%20six%20forest%20types%20of%20Uttaranchal,%20Central%20Himalaya.pdf"
              target="_blank"
            >
              Plant diversity in six forest types of Uttaranchal, Central
              Himalaya.pdf
            </Link>
          </li>

          <li>
            Plant diversity in the Kamthi Formation of India: A Review
            <br />
            <Link
              to="/pdfs/reports/38_Plant%20diversity%20in%20the%20Kamthi%20Formation%20of%20India_A%20review.pdf"
              target="_blank"
            >
              Plant diversity in the Kamthi Formation of India_A review.pdf
            </Link>
          </li>

          <li>
            Spatial distribution pattern of taxonomic and phylogenetic diversity
            of woody flora in Andaman and Nicobar Islands, India
            <br />
            <Link
              to="/pdfs/reports/39_Spatial%20distribution%20pattern%20of%20taxonomic%20and%20phylogenetic%20diversity%20of%20woody%20flora%20in%20Andaman%20and%20Nicobar%20Islands.pdf"
              target="_blank"
            >
              Spatial distribution pattern of taxonomic and phylogenetic
              diversity of woody flora in Andaman and Nicobar Islands.pdf
            </Link>
          </li>

          <li>
            Seagrass Diversity and Associated Flora and Fauna in the Coral Reef
            Ecosystem of the Gulf of Mannar, Southeast Coast of India
            <br />
            <Link
              to="/pdfs/reports/40_Seagrass_Diversity_and_Associated_Flora_and_Fauna_.pdf"
              target="_blank"
            >
              Seagrass_Diversity_and_Associated_Flora_and_Fauna_.pdf
            </Link>
          </li>

          <li>
            Diversity of Angio spermic flora of Darjeeling Hills
            <br />
            <Link
              to="/pdfs/reports/41_Diversity_of_Angiospermic_Flora_of_Darjeeling%20Hills.pdf"
              target="_blank"
            >
              Diversity_of_Angiospermic_Flora_of_Darjeeling Hills.pdf
            </Link>
          </li>

          <li>
            Diversity of nectariferous and polleniferous bee flora at Anjaneri
            and Dugarwadi hills of Western Ghats of Nasik district (M. S.) India
            <br />
            <Link
              to="/pdfs/reports/42_Diversity%20of%20nectariferous%20and%20polleniferous%20bee%20flora%20at%20Anjaneri%20Hills%20of%20EG%20of%20Nasik%20district%20India.pdf"
              target="_blank"
            >
              Diversity of nectariferous and polleniferous bee flora at Anjaneri
              Hills of EG of Nasik district India.pdf
            </Link>
          </li>

          <li>
            An evaluation of flora from coastal sand dunes of India: Rationale
            for conservation and management
            <br />
            <Link
              to="/pdfs/reports/43_An%20evaluation%20of%20flora%20from%20coastal%20sand%20dunes%20of%20India_Rationale%20for%20conservation%20and%20management.pdf"
              target="_blank"
            >
              An evaluation of flora from coastal sand dunes of India_Rationale
              for conservation and management.pdf
            </Link>
          </li>

          <li>
            Endemic genera of Angiosperms in India: A Review
            <br />
            <Link
              to="/pdfs/reports/44_Endemic%20genera%20of%20Angiosperms%20in%20India_A%20review.pdf"
              target="_blank"
            >
              Endemic genera of Angiosperms in India_A review.pdf
            </Link>
          </li>

          <li>
            Geographic distribution pattern of threatened plants of India and
            steps taken for their conservation
            <br />
            <Link
              to="/pdfs/reports/45_Geographic%20distribution%20pattern%20of%20threatened%20plants%20of%20India%20and%20steps%20taken%20for%20their%20conservation.pdf"
              target="_blank"
            >
              Geographic distribution pattern of threatened plants of India and
              steps taken for their conservation.pdf
            </Link>
          </li>
        </ol>
      }
    />
  );
}

export default ReportsPage;
